import React, { useEffect, useMemo, useState } from 'react'
import styles from './ExpertComment.module.css'
import { MyIcon } from '~/components/ui/MyIcon'
import { MyImage } from '~/components/ui/MyImage'
import classNames from 'classnames'
import { useRouter } from 'next/router'

export interface ExpertCommentType {
  commentTempId?: any
  avatarUrl?: string
  expertName?: string
  commentContent?: string
  hasMore?: boolean
}
const PAGE_SIZE = 2

export const ExpertComment: React.FC<{ data: ExpertCommentType[] }> = ({
  data: _data,
}) => {
  const [data, setData] = useState<ExpertCommentType[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isHide, setIsHide] = useState<boolean>(false)
  const router = useRouter()
  useEffect(() => {
    setData(_data)
    setIsHide(false)
    setCurrentPage(1)
  }, [_data, router.asPath])

  const total = useMemo(() => {
    return data.length
  }, [data])
  /** 上一页 */
  const onLastPage = () => {
    if ((currentPage - 1) * PAGE_SIZE <= 0) {
      return
    }
    setCurrentPage(pre => (pre -= 1))
  }
  /** 下一页 */
  const onNextPage = () => {
    if (currentPage * PAGE_SIZE >= total) {
      return
    }
    setCurrentPage(pre => (pre += 1))
  }
  /** 查看更多 */
  const handleCheckMore = (id: string) => {
    const list = [...data].map(it => {
      if (it?.commentTempId === id) {
        it.hasMore = true
      }
      return it
    })
    setData(list)
  }
  if (total === 0 || isHide) {
    return null
  }
  return (
    <div className={styles.expertCommentWrap}>
      <div className={styles.content}>
        <div className={styles.top}>
          <div className={styles.title}>专家评语</div>
          <div className={styles.hide} onClick={() => setIsHide(true)}>
            隐藏
          </div>
        </div>
        {data
          .slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
          .map((item, i) => (
            <div className="mb-3 last:mb-0" key={item.commentTempId || i}>
              <div className="flex items-center mb-1">
                <MyImage
                  tag="v400"
                  src={item.avatarUrl}
                  className="w-6 h-6 rounded-[50%]"
                  alt=""
                />
                <span className="ml-2 font-semibold text-neutral-900 text-xs">
                  {item.expertName}
                </span>
              </div>
              <div className="text-neutral-900 text-xs">
                {!item?.hasMore
                  ? item.commentContent?.slice(0, 45)
                  : item.commentContent}
                {!item?.hasMore &&
                  item.commentContent &&
                  item.commentContent.length > 45 && (
                    <span
                      className="cursor-pointer font-bold"
                      onClick={() => handleCheckMore(item.commentTempId)}
                    >
                      .查看更多
                    </span>
                  )}
              </div>
            </div>
          ))}
        {total > 2 && (
          <div className="flex justify-center mt-3">
            <div
              className="w-6 h-6 bg-neutral-200 rounded-[4px] flex items-center justify-center cursor-pointer"
              onClick={onLastPage}
            >
              <MyIcon
                icon="left"
                className={classNames('text-neutral-900 text-[20px]', {
                  ['text-neutral-400']: (currentPage - 1) * PAGE_SIZE <= 0,
                })}
              />
            </div>
            <div
              className="w-6 h-6 bg-neutral-200 rounded-[4px] flex items-center justify-center ml-4 cursor-pointer"
              onClick={onNextPage}
            >
              <MyIcon
                icon="right"
                className={classNames('text-neutral-900 text-[20px]', {
                  ['text-neutral-400']: currentPage * PAGE_SIZE >= total,
                })}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
